import { Inject, Injectable } from '@angular/core';
import { ProductErrors, ProductErrorsRepository } from '@infrab4a/connect';
import { PageContent } from 'src/app/components/table';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopProductErrorsService extends BaseConnectService<ProductErrors> {
  constructor(
    @Inject('ProductErrorsRepository')
    private productErrorsRepository: ProductErrorsRepository
  ) {
    super(productErrorsRepository);
  }

  async getProductErrorsList(
    request: Partial<ConnectRequest>
  ): Promise<PageContent<Partial<ProductErrors>>> {
    const { data: content, ...result } = await this.paginatedSearch({
      ...request,
      filters: [...request.filters]
    });
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }

  async getProductErrorsById(productId: string): Promise<ProductErrors[]> {
    try {
      const result = await this.productErrorsRepository.find({
        filters: {
          productId
        }
      });

      return result.data;
    } catch (error) {
      console.error('Erro ao buscar erros do produto:', error);

      return [];
    }
  }

  async getProductErrorDescriptions(): Promise<string[]> {
    const result = await this.productErrorsRepository.find({
      options: {
        distinct: ['error']
      }
    });

    return result.distinct?.error || [];
  }

  override get scheme(): 'firebase' | 'hasura' {
    return 'hasura';
  }
}
